
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-slack-apps",
      function () {
        return require("private-next-pages/best-slack-apps.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-slack-apps"])
      });
    }
  